import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'projects/packcert-web/src/environments/environment';

@Injectable()
export class HistoricoService {

    private _httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    constructor(private readonly _http: HttpClient) {}

    // HISTORICO CULTIVOS
    public getHistoricoCultivos(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/HCJ/GetHCJCultivos', filters);
    }

    // HISTORICO DESIGNACIONES
    public getHistoricoDesignaciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/HCJ/GetHCJDesignaciones', filters);
    }

    // HISTORICO  CONSUMOS
    public getHistoricoConsumos(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/HCJ/GetHCJConsumoGestion', filters);
    }

    // HISTORICO REETIQUETADO
    public getHistoricoReetiquetado(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/HCJ/GetHCJReetiquetado', filters);
    }

    // HISTORICO ETIQUETADO
    public getHistoricoEtiquetado(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/HCJ/GetHCJEtiquetado', filters);
    }

    // HISTORICO TOTALES
    public getHistoricoTotales(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/HCJ/GetReportHCJConsumosTotalesResumen', filters);
    }

    // PAIS - DENOMINACION
    public getDenominaciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Denominacion/GetAllConFiltro', filters);
    }

    // CAMPANYAS
    public getCampanyasMultiSelect(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Campanya/GetAnyosCampanyaByFiltro', filters);
    }

    public getCampanyas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Campanya/GetAllConFiltro', filters);
    }

    // CULTIVOS
    public getCultivos(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Cultivo/GetAllConFiltro', filters);
    }

    // PROVINCIAS
    public getProvincias(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Provincia/GetAllConFiltro', filters);
    }

    // MUNICIPIOS
    public getMunicipios(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Municipio/GetAllConFiltro', filters);
    }

    // ETIQUETADORES
    public getEtiquetadores(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Etiquetador/GetAllConFiltro', filters);
    }

    // MARCAS
    public getMarcas(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Marca/GetAllConFiltro', filters);
    }

    // CONFECCIONES
    public getConfecciones(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Confeccion/GetAllConFiltro', filters);
    }

    // ALMACENES
    public getAlmacenes(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Almacen/GetAllConFiltro', filters);
    }

    // AYUDA
    public getDocHelp(nombreArchivo: string) {
      return this._http.get<any>(environment.apiEndpoint + '/Utilities/GetDocHelp/?nombreArchivo=' + nombreArchivo);
    }

    // REPORT CULTIVOS
    public getRepHistoricoCultivos(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepHistoricoCultivo', filters);
    }

    // REPORT DESIGNACIONES
    public getRepHistoricoDesignacion(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepHistoricoDesignacion', filters);
    }

    // REPORT ETIQUETADO
    public getRepHistoricoEtiquetado(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepHistoricoEtiquetado', filters);
    }

    // REPORT REETIQUETADO
    public getRepHistoricoReetiquetado(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepHistoricoReetiquetado', filters);
    }

    // REPORT TOTALES
    public getRepHistoricoTotales(filters) {
        return this._http.post<any>(environment.apiEndpoint + '/Report/GetRepHistoricoConsumoTotales', filters);
    }
}
